'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _AlertBar = require('@icare/components/lib/AlertBar/AlertBar');

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalAlertBar = (_temp = _class = function (_React$Component) {
	_inherits(GlobalAlertBar, _React$Component);

	function GlobalAlertBar(props) {
		var _this2 = this;

		_classCallCheck(this, GlobalAlertBar);

		var _this = _possibleConstructorReturn(this, (GlobalAlertBar.__proto__ || Object.getPrototypeOf(GlobalAlertBar)).call(this, props));

		_this.componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
			var _this$props, siteApiUrl, siteAlertUrl, resp;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_this$props = _this.props, siteApiUrl = _this$props.siteApiUrl, siteAlertUrl = _this$props.siteAlertUrl;
							_context.next = 3;
							return _superagent2.default.get(siteApiUrl + '/' + siteAlertUrl);

						case 3:
							resp = _context.sent;

							if (resp.body && resp.body.data && resp.body.data.attributes && resp.body.data.attributes.alerts) {
								_this.setState({ showAlertMessage: true, data: resp.body.data.attributes.alerts });
							} else {
								_this.setState({ showAlertMessage: false, data: null });
							}

						case 5:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		}));


		_this.state = {
			showAlertMessage: false,
			data: null
		};
		return _this;
	}

	_createClass(GlobalAlertBar, [{
		key: 'render',
		value: function render() {
			var _state = this.state,
			    showAlertMessage = _state.showAlertMessage,
			    data = _state.data;


			if (!showAlertMessage) {
				return null;
			}
			return _react2.default.createElement(_AlertBar2.default, { data: data, showAlertMessage: showAlertMessage });
		}
	}]);

	return GlobalAlertBar;
}(_react2.default.Component), _class.propTypes = {
	siteApiUrl: _propTypes2.default.string.isRequired,
	siteAlertUrl: _propTypes2.default.string
}, _class.defaultProps = {
	siteAlertUrl: 'api/sitealerts'
}, _temp);
exports.default = GlobalAlertBar;
//# sourceMappingURL=GlobalAlertBar.js.map